import useSWR from 'swr'

import { MeetingsAPI } from 'api/index'

import useOrgUsers, { User } from './useOrgUsers'

const fetcher = (url: string) => MeetingsAPI.get(url).then((res) => res.data)

export default function useCalendarConnectedUsers() {
  const {
    data: calendarConnectedUsers,
    error,
    isLoading,
  } = useSWR<number[]>('/scheduling/settings/connected', fetcher)
  const orgUsers = useOrgUsers()

  const filteredConnectedAgents = orgUsers.filter((agent: User) =>
    calendarConnectedUsers?.includes(agent.id)
  )

  return {
    filteredConnectedAgents,
    isLoading: isLoading || error,
    isError: error,
  }
}
